<template>
  <draggable :list="objList" handle=".handle" @change="onMove" v-bind="dragOptions" class="w-100" style="min-height: 0.65rem; padding-top: 0.65rem;" >
    <div class="d-flex flex-column w-100 mt-1" v-for="(obj, index) in objList" :key="obj.id" :index="index">
      <div class="d-flex w-100">
        <i class="fa fa-align-justify handle pointer p-2"></i>
        <b-form-select  name="txtLogicalOperator"
                        v-model="obj.tipoOperadorLogico"
                        @change="$emit('update', obj)"
                        :options="form.tipoOperadorLogico.options"
                        :required="form.tipoOperadorLogico.required"
                        style="max-width: max-content;"
                        class="mr-1 border"
                        :class="{'border-danger': warningType(obj, index)}">
        </b-form-select>
        <div class="form-control mr-1 border" style="max-width: max-content; border: 1px solid lightgray" :class="{'border-danger': warningItem(obj, index)}">
          <span v-if="obj.pciModeloItem" v-b-tooltip.hover :title="obj.pciModeloItem.pais || '>'">
            {{ '(' + obj.pciModeloItem.codigo + ') ' + obj.pciModeloItem.descricao}}
          </span>
          <span v-else-if="obj.pciItemFixo">
            {{ loadParentsFixedItem(obj.pciItemFixo) }}
          </span>
          <span v-else>{{' - '}}</span>
          <img v-if="searchingItem && editObj && editObj.id == obj.id" src="/static/img/loader.gif" alt="">
          <i v-else class="fas fa-search pointer ml-1" @click="onOpenModal({ obj, index })"></i>
        </div>
        <b-form-select  name="txtValidationType"
                        v-if="obj.pciModeloItem || obj.pciItemFixo"
                        v-model="obj.tipoValidacao"
                        @change="$emit('update', obj)"
                        :options="form.tipoValidacao.options"
                        :state="form.tipoValidacao.state"
                        :required="form.tipoValidacao.required"
                        style="max-width: max-content;"
                        class="mr-1">
        </b-form-select>
        <div v-if="parseInt(obj.tipoValidacao) >= 50" class="form-control mr-1" style="max-width: max-content; border: 1px solid lightgray;">
          <span v-if="obj.pciModeloItemComparar" v-b-tooltip.hover :title="obj.pciModeloItemComparar.pais || '>'">
            {{'(' + obj.pciModeloItemComparar.codigo + ') ' + obj.pciModeloItemComparar.descricao}}
          </span>
          <span v-else>{{' - '}}</span>
          <img v-if="searchingCompareItem && editObj && editObj.id == obj.id" src="/static/img/loader.gif" alt="">
          <i v-else class="fas fa-search pointer ml-1" @click="onOpenModalCompare({ obj, index })"></i>
        </div>
        <b-form-input name="txtConstant"
                      class="mr-1"
                      v-if="(
                        parseInt(obj.tipoValidacao) >= 10 && parseInt(obj.tipoValidacao) < 50)
                        || (parseInt(obj.tipoValidacao) >= 56
                      )"
                      v-model="obj.constante"
                      @change="$emit('update', obj)"
                      :state="form.constante.state"
                      :maxlength="form.constante.maxlength"
                      :required="form.constante.required"
                      :placeholder="$lang.PCI.Items.ValidationStatusAutomation.LabelConstant"
                      style="max-width: 200px;">
        </b-form-input>
        <b-form-input type="number"
                      name="txtTolerance"
                      class="mr-1"
                      v-if="(parseInt(obj.tipoValidacao) >= 10 && parseInt(obj.tipoValidacao) <= 15)
                        || (parseInt(obj.tipoValidacao) >= 50 && parseInt(obj.tipoValidacao) <= 55)"
                      v-model="obj.tolerancia"
                      @change="$emit('update', obj)"
                      :required="form.tolerancia.required"
                      :state="form.tolerancia.state"
                      :placeholder="$lang.PCI.Items.ValidationStatusAutomation.LabelTolerance"
                      style="max-width: 7rem;">
        </b-form-input>
        <b-dropdown href="#"
                    variant="link"
                    toggle-class="text-decoration-none p-0"
                    dropup
                    no-caret
                    tabindex="-1"
                    v-if="!obj.regras.length"
                    v-b-tooltip.hover
                    :title="$lang.Common.Tooltip.ButtonDelete">
          <template #button-content>
            <i class="fa fa-trash text-danger p-1"
              style="cursor:pointer">
            </i>
          </template>
          <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
          <b-dropdown-item href="#" v-on:click="onRemove(obj)">{{$lang.Common.Yes}}</b-dropdown-item>
          <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
        </b-dropdown>
        <i class="fas fa-exclamation-triangle text-danger m-2" v-if="warning(obj, index)"></i>
      </div>
      <div class="d-flex w-100 pl-3 item-sub">
        <add-valid-autom-rules  :objList="obj.regras"
                                :form="form"
                                :searchingItem="searchingItem"
                                :searchingCompareItem="searchingCompareItem"
                                :fatherId="obj.id"
                                :itemIndex="itemIndex"
                                :tipo="tipo"
                                @change-father="onChangeFather"
                                @change-position="$emit('change-position')"
                                @open-modal="onOpenModal"
                                @open-modal-compare="params => onOpenModalCompare(params)"
                                @move="onMove"
                                @remove="onRemove"
                                @update="obj => $emit('update', obj)">
        </add-valid-autom-rules>
      </div>
    </div>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'AddValidAutomRules',
  components: {
    draggable
  },
  props: {
    objList: {
      type: Array,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    searchingItem: {
      type: Boolean,
      required: true
    },
    searchingCompareItem: {
      type: Boolean,
      required: true
    },
    itemIndex: {
      type: Number,
      required: true
    },
    fatherId: {
      type: String,
      require: false,
      default: null
    },
    tipo: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      editObj: null,
      tipoEnum: {
        VALIDATION: 'VALIDATION',
        AUTOMATION: 'AUTOMATION'
      },
      dragOptions: {
        animation: 0,
        disabled: false,
        group: 'regras',
        ghostClass: 'ghost'
      }
    }
  },
  methods: {
    onRemove (obj) {
      const index = this.objList.findIndex(o => o.id === obj.id)
      if (index > -1) {
        this.objList.splice(index, 1)
      }
      this.$emit('remove', obj)
    },
    onUpdate (obj) {
      this.$emit('update', obj)
    },
    onMove (event) {
      if (event.added) {
        this.$nextTick(() => {
          const idx = this.objList.findIndex(o => o.id === event.added.element.id)
          if (this.tipo === this.tipoEnum.VALIDATION) {
            const value = this.objList[idx]
            value.pciModeloItemValidRegraIDPai = this.fatherId
            value.pciModeloItemRegraBaseIDPai = this.fatherId
            this.$set(this.objList, idx, value)
          } else if (this.tipo === this.tipoEnum.AUTOMATION) {
            const value = this.objList[idx]
            value.pciModeloItemStatusRegraIDPai = this.fatherId
            value.pciModeloItemRegraBaseIDPai = this.fatherId
            this.$set(this.objList, idx, value)
          }
          this.$emit('change-father', {id: event.added.element.id, fatherId: this.fatherId})
        })
      }
      if (event.moved) {
        this.$nextTick(() => {
          this.$emit('change-position')
        })
      }
    },
    onOpenModal (params) {
      this.editObj = params.obj
      this.$emit('open-modal', params)
    },
    onOpenModalCompare (params) {
      this.editObj = params.obj
      this.$emit('open-modal-compare', params)
    },
    loadParentsFixedItem (item) {
      let result = ' - '
      if (item) {
        const fatherId = parseInt(item / 10) * 10
        const prefix = this.form.pciItemFixo.options.filter(fi => fi.code === fatherId)[0].text

        result = prefix + ' > ' + this.form.pciItemFixo.options.filter(fi => fi.code === item)[0].text
      }
      return result
    },
    onChangeFather (params) {
      this.$nextTick(() => {
        this.$emit('change-father', params)
      })
    },
    warningType (obj, index) {
      if ((index === 0 && obj.tipoOperadorLogico !== 0) || (index > 0 && obj.tipoOperadorLogico === 0)) {
        return true
      }
      return false
    },
    warningItem (obj, index) {
      if (obj.regras.length > 0 && obj.pciModeloItemID) {
        return true
      }
      return false
    },
    // warning (obj, index) {
    //   return this.warningType(obj, index) || this.warningItem(obj, index)
    // }
    warning (obj, index) {
      const hasWarning = this.warningType(obj, index) || this.warningItem(obj, index)
      this.$emit('validation-warning', { index, hasWarning })
      return hasWarning
    }
  }
}
</script>

<style scoped>
  .item-sub {
    margin: 0 0 0 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/items/addValidAutomRules.vue